import React from 'react';

export default class Output extends React.Component {
  constructor(){
    super();
    this.state={
    }
  }
  render() {
    return (
      <div>
        <p>wartości zwrócone przez maszynę:</p>
        <ol>{this.props.result.map((e)=><li>{e}</li>)}</ol>
      </div>);
  }
}

/*
LOAD =11
READ 1
ADD 1
WRITE =5555
WRITE 0
STORE 15
WRITE 15
HALT
*/


// WEBPACK FOOTER //
// ./components/Output.jsx